import { useEffect, useState } from 'react';
import queryString from 'query-string';
import GuestIdForm from 'src/containers/CheckIn/guestIdForm';
import GuestData from 'src/containers/CheckIn/guestData';
import useCheckInGuest from 'src/containers/CheckIn/useCheckInGuest';
import EventService from 'src/services/api/eventService';
import { CheckinURL } from 'src/components/helpers';
import {
  isCaptchaRequired,
  useRecaptchaToken,
  RECAPTCHA_SECURITY_ERROR,
} from 'src/components/helpers/recaptchaUtils';

const CRECER_EVENT_URL = CheckinURL('crecer');

const CrecerCheckIn = (props) => {
  const parsedQueryString = queryString.parse(props.location.search);
  const [eventDates, setEventDates] = useState([]);
  const getCaptchaToken = useRecaptchaToken('crecer_attendance');

  const getRequestBody = async () => {
    if (!isCaptchaRequired()) return {};

    const captcha = await getCaptchaToken();
    if (!captcha) throw new Error(RECAPTCHA_SECURITY_ERROR);

    return { captcha };
  };

  const {
    guestID,
    setGuestID,
    Attendant,
    setAttendant,
    loadedData,
    errorData,
    setErrorData,
    getAttendant,
    getAttendantInfo,
    resetForm,
    handleInputs,
    handleDropDown,
  } = useCheckInGuest({
    eventURL: CRECER_EVENT_URL,
    initialId: parsedQueryString.id,
    getRequestBody,
  });

  useEffect(() => {
    EventService.getDates()
      .then((response) => {
        if (response.data.success) {
          setEventDates(response.data.dates);
        }
      })
      .catch((error) => {
        if (error.response) setErrorData(error.response.data.message);
      });
  }, [setErrorData]);

  const handleReset = () => {
    resetForm();
    props.history.push('/checkin/crecer');
  };

  return Attendant.name ? (
    <GuestData
      mode="crecer"
      Attendant={Attendant}
      handleInputs={handleInputs}
      resetForm={handleReset}
      errorData={errorData}
      eventDates={eventDates}
      set_errorData={setErrorData}
      set_Attendant={setAttendant}
      location={props.location}
      handleDropDown={handleDropDown}
      getAttendantInfo={getAttendantInfo}
    />
  ) : (
    <GuestIdForm
      title="Ingreso Crecer"
      guestID={guestID}
      set_guestID={setGuestID}
      getAttendant={getAttendant}
      history={props.history}
      loadedData={loadedData}
      errorData={errorData}
      showEventSelect={false}
    />
  );
};

export default CrecerCheckIn;
